import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaginationService {
  private readonly STORAGE_KEY = 'page-size-preferences';

  private defaultPageSize = 20;

  private allowedPageSizes = [10, 20, 50, 100];

  getPageSize(module: string): number {
    const prefs = this.getPreferences();
    return prefs[module] ?? this.defaultPageSize;
  }

  setPageSize(module: string, size: number): void {
    if (!this.allowedPageSizes.includes(size)) {
      return;
    }

    const prefs = this.getPreferences();
    prefs[module] = size;
    this.savePreferences(prefs);
  }

  private getPreferences(): Record<string, number> {
    try {
      const savedPreference = localStorage.getItem(this.STORAGE_KEY);
      return savedPreference ? JSON.parse(savedPreference) : {};
    } catch {
      return {};
    }
  }

  private savePreferences(prefs: Record<string, number>): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(prefs));
  }

  resetPageSize(module: string): void {
    const prefs = this.getPreferences();
    delete prefs[module];
    this.savePreferences(prefs);
  }

  resetAll(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  getAllowedSizes(): number[] {
    return this.allowedPageSizes;
  }
}
